import { DataBean } from "../DataBean";

export class ProductionRoute extends DataBean {

    public async getProductionOrderCatalog(idProductionRoute: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProductionRouteCatalog_Number", [idProductionRoute]);
    }

    public async getProductionRouteCatalog(idProductionRoute: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProductionRouteCatalog_Number", [idProductionRoute]);
    }

    public async getProductionRouteCatalogdos(regexStr: any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getProductionRouteCatalog_String_Number_Number", [regexStr,page,recordsPerPage]);
    }

    public async updateProductionRoute(bean: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.productionorders.ProductionRoute_updateProductionRoute_com.quickdataerp.bean.productionorders.ProductionRoute", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.quickdataerp.bean.productionorders.ProductionRoute"
            }
        ]);
    }

    public async deleteProductionRoute(idProductionRoute: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteProductionRoute_Number", [idProductionRoute]);
    }

    public async imporLabourCatalog(idProductionRoute: number, filename: string, directory: string, dataStore: string): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_imporLabourCatalog_Number_String_String_String", [idProductionRoute, filename, directory, dataStore]);
    }

}
